import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <p>&copy; Shay Apparel</p>
      <Link to="/women">Womens</Link>
      <Link to="/kids">Kids</Link>
    </footer>
  );
}

export default Footer;
